import axios, { AxiosRequestConfig } from 'axios';

import { axiosQueue } from '@/bundles/Auth/services/AxiosQueue';
import { REQUEST_CANCELLED_MESSAGE } from '@/bundles/Http/mappers/ErrorMapper';
import { removeCancelToken } from '@/bundles/Http/interceptors/requestInterceptor';

export async function responseErrorInterceptor (error: any) {
  // Also on the 401 path below: AxiosQueue re-issues the request through the bare
  // axios instance, which has no request interceptor, so the entry would never be
  // removed if it were kept here.
  removeCancelToken(error?.config);
  if (axios.isCancel(error)) {
    throw Error(REQUEST_CANCELLED_MESSAGE);
  }
  // a 401 from the sign-out means the session is already gone: refreshing it would only sign out again
  const ignoreUrls = ['auth/sign-in', 'auth/account-sign-in', 'auth/logout'];
  if (error.response?.status === 401 && !ignoreUrls.some((url) => error.response?.request?.responseURL?.includes(url))) {
    return new Promise((resolve, reject) => axiosQueue.addToQueue(error.response.config as AxiosRequestConfig, resolve, reject));
  }
  throw error;
}
